import { prescriptionMode } from '@/constants/constants';
import { create } from 'zustand';

export const useExerciseLibrary = create((set, get) => ({
  mode: prescriptionMode.PRESCRIPTION, // prescription | template | edit
  openNotesView: false,
  EditTemplateData: [],
  selectedCard: [],
  setMode: value => set({ mode: value }), //setIsEditMode, isEditMode
  setEditTemplateData: value => {
    set({ EditTemplateData: value });
  },
  addEditTemplateData: value => {
    //add object
    const current = get().EditTemplateData;
    set({ EditTemplateData: [...current, ...value] });
  },
  setSelectedCard: updater =>
    set(state => {
      if (typeof updater === 'function') {
        return { selectedCard: updater(state.selectedCard) };
      }
      return { selectedCard: updater };
    }),
  setOpenNotesView: value => set({ openNotesView: value }),
}));
